import { useEffect } from 'react';

import { useAlbumContext } from '@/utils/hooks/context/useAlbumContext';
import useDateLimits from '@/utils/hooks/datepicker/useDateLimits';
// Hooks
import useMedias from '@/utils/hooks/swr/useMedias';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';

import MediaSelectionSection from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/MediaSelectionSection';
// Components
import PostsList from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/PostsList';

const PostListWrapper = () => {
    const { albumInfo } = useAlbumContext();
    const { getMinDate, getMaxDate } = useDateLimits();
    const { activeSocialProfile } = useActiveSocialProfile();
    const {
        dataMedias,
        isLoadingInitialData,
        isLoadingMore,
        isLoadMore,
        loadMoreMedia,
        setRequestParams,
        mutateMedias
    } = useMedias({
        activeSPID: activeSocialProfile?.id,
        params: {
            period: 'custom',
            with_labels: true, // Required for filter_labels param
            start:
                albumInfo?.criteria?.started_at && albumInfo?.criteria?.started_at !== ''
                    ? albumInfo?.criteria?.started_at?.slice(0, 10)
                    : getMinDate(activeSocialProfile)?.slice(0, 10),
            end:
                albumInfo?.criteria?.ended_at && albumInfo?.criteria?.ended_at !== ''
                    ? albumInfo?.criteria?.ended_at?.slice(0, 10)
                    : getMaxDate(activeSocialProfile)?.slice(0, 10),
            filter_labels: albumInfo?.criteria?.labels ?? [],
            filter_hashtags: albumInfo?.criteria?.hashtags ?? [],
            filter_post_type: albumInfo?.criteria?.post_types ?? []
        }
    });

    useEffect(() => {
        setRequestParams((prevState) => ({
            ...prevState,
            start:
                albumInfo?.criteria?.started_at && albumInfo?.criteria?.started_at !== ''
                    ? albumInfo?.criteria?.started_at?.slice(0, 10)
                    : getMinDate(activeSocialProfile)?.slice(0, 10),
            end:
                albumInfo?.criteria?.ended_at && albumInfo?.criteria?.ended_at !== ''
                    ? albumInfo?.criteria?.ended_at?.slice(0, 10)
                    : getMaxDate(activeSocialProfile)?.slice(0, 10),
            filter_labels: albumInfo?.criteria?.labels ?? [],
            filter_hashtags: albumInfo?.criteria?.hashtags ?? [],
            filter_post_type: albumInfo?.criteria?.post_types ?? []
        }));
    }, [
        albumInfo?.criteria?.started_at,
        albumInfo?.criteria?.ended_at,
        albumInfo?.criteria?.labels,
        albumInfo?.criteria?.hashtags,
        albumInfo?.criteria?.post_types
    ]);

    return (
        <>
            <MediaSelectionSection dataMedias={dataMedias} />
            <PostsList
                dataMedias={dataMedias}
                isLoadingInitialData={isLoadingInitialData}
                isLoadingMore={isLoadingMore}
                isLoadMore={isLoadMore}
                loadMoreMedia={loadMoreMedia}
                mutateMedias={mutateMedias}
            />
        </>
    );
};

export default PostListWrapper;
